var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.print.isPrinting)?_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.print.isPrinting),expression:"print.isPrinting"}],staticClass:"print-dialog",attrs:{"element-loading-text":_vm.print.text}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }